import * as React from "react";
import { ResponsiveLine, Serie } from '@nivo/line';
import { roundToBottom, roundToTop, createRange } from "../../../misc/math-functions";

interface VolumeTimeGraphProps {
    data: Serie[];
    minTime: number;
    maxTime: number;
    minVolume: number;
    maxVolume: number;
}

function scaleGraph(minTime, maxTime, minVolume, maxVolume) {
    const minV = roundToBottom(minVolume);
    const maxV = roundToTop(maxVolume);

    const minT = roundToBottom(minTime);
    const maxT = roundToTop(maxTime);

    const xTicks = createRange(minT, maxT, 1);
    xTicks.push(maxT);

    const yTicks = createRange(minV, maxV, 1);
    yTicks.push(maxV);

    return {
        minT,
        maxT,
        minV,
        maxV,
        xTicks,
        yTicks
    }
}

export const SvcVolumeTimeGraph = ({ data, minTime, maxTime, minVolume, maxVolume }: VolumeTimeGraphProps) => {
    const {
        minT,
        maxT,
        minV,
        maxV,
        xTicks,
        yTicks
    } = scaleGraph(minTime, maxTime, minVolume, maxVolume);

    return (<ResponsiveLine
        data={data}
        curve="basis"
        margin={{ top: 30, right: 160, bottom: 50, left: 60 }}
        xScale={{ type: 'linear', min: minT, max: maxT }}
        yScale={{ type: 'linear', min: minV, max: maxV }}
        colors={d => d.color}
        animate={false}
        axisTop={null}
        axisRight={null}
        axisBottom={{
            tickValues: xTicks,
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legend: 'Time',
            legendOffset: 30,
            legendPosition: 'middle'
        }}
        axisLeft={{
            tickValues: yTicks,
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legend: 'Volume (L)',
            legendOffset: -40,
            legendPosition: 'middle'
        }}
        lineWidth={1}
        enablePoints={false}
        enablePointLabel={false}
        useMesh={true}
        enableCrosshair={true}
        tooltip={({ point }) => {
            return <div className="lineChartTooltip">
                <span className="lineChartTooltipIcon" style={{ background: point.color }}></span>
                <span>Time: <strong>{point.data.x}</strong> Volume: <strong>{point.data.y}</strong></span>
            </div>
        }}
        isInteractive={true}
        gridXValues={xTicks}
        gridYValues={yTicks}
        legends={[
            {
                anchor: 'top',
                direction: 'row',
                justify: false,
                translateX: 10,
                translateY: -20,
                itemsSpacing: 2,
                itemDirection: 'left-to-right',
                itemWidth: 80,
                itemHeight: 12,
                itemOpacity: 0.75,
                symbolSize: 12,
                symbolShape: 'square',
                symbolBorderColor: 'rgba(0, 0, 0, .5)',
            }
        ]}
        markers={[
            {
                value: 0,
                axis: 'y',
                lineStyle: {
                    stroke: 'black'
                }
            },
            {
                value: 0,
                axis: 'x',
                lineStyle: {
                    stroke: 'black'
                }
            }
        ]}
    />);
}
